import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Loader2, Shuffle, Wand2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api } from "@/lib/api";
import QuizRunner from "@/components/QuizRunner";

export default function MixedReview() {
  const { subjectId } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const generate = async () => {
    setLoading(true);
    try {
      const res = await api.mixedQuiz(subjectId, 8);
      setData(res);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore nella generazione del ripasso.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { generate(); /* eslint-disable-next-line */ }, [subjectId]);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8">
      <Link to="/" data-testid="mixed-back-link" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground mb-4 transition-colors">
        <ArrowLeft className="h-4 w-4" /> Torna ai materiali
      </Link>

      <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
        <div className="flex items-center gap-2 mb-6">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary text-primary-foreground">
            <Shuffle className="h-5 w-5" />
          </span>
          <div>
            <h1 className="font-display text-2xl font-extrabold tracking-tight leading-none">Ripasso Misto</h1>
            {data?.subject_name && <p className="text-sm text-muted-foreground mt-1">{data.subject_name}</p>}
          </div>
        </div>

        <div className="bg-card border border-border rounded-2xl p-5 sm:p-6 shadow-sm">
          {loading ? (
            <div className="text-center py-14">
              <Loader2 className="h-7 w-7 animate-spin text-primary mx-auto mb-3" />
              <p className="text-sm text-muted-foreground">Sto mescolando le domande da tutti i materiali...</p>
            </div>
          ) : data?.questions?.length > 0 ? (
            <div>
              <QuizRunner questions={data.questions} timer />
              <div className="mt-6 pt-4 border-t border-border flex justify-center">
                <Button data-testid="mixed-new-button" variant="secondary" size="sm" className="rounded-xl gap-2" onClick={generate}>
                  <Wand2 className="h-4 w-4" /> Nuovo ripasso misto
                </Button>
              </div>
            </div>
          ) : (
            <div className="text-center py-10">
              <p className="text-sm text-muted-foreground mb-4">Non è stato possibile generare il ripasso.</p>
              <Button data-testid="mixed-retry-button" onClick={generate} className="rounded-xl gap-2"><Wand2 className="h-4 w-4" /> Riprova</Button>
            </div>
          )}
        </div>
      </motion.div>
    </div>
  );
}
